import React, { useState } from "react";
import { ReactComponent as ModalCloseIcon } from "../../../assets/svg/close.svg";
import { ReactComponent as CalendarIcon } from "../../../assets/svg/new_calendar_icon.svg";
import { ReactComponent as ArrowDownIcon } from "../../../assets/svg/mark_down.svg";
import "./manual-modals.css";

// Constants localized to this file
const STATUS_OPTIONS = ["Active", "Inactive"];

// Internal Reusable Components
const FormField = ({ label, required, children }) => (
  <div className="lm-input-group">
    <label className="lm-label">
      {label}
      {required && <span className="lm-required">*</span>}
    </label>
    {children}
  </div>
);

const DateInput = ({ placeholder = "dd/mm/yyyy", value, onChange }) => (
  <div className="lm-input-wrapper">
    <input type="date" placeholder={placeholder} className="lm-input" value={value} onChange={(e) => onChange(e.target.value)} onClick={(e) => e.target.showPicker?.()} />
    <CalendarIcon className="lm-icon-calendar" width="20" height="20" />
  </div>
);

const SelectInput = ({ value, onChange, options = [], placeholder = "Select" }) => (
  <div className="lm-input-wrapper">
    <select className="lm-input lm-select" value={value} onChange={(e) => onChange(e.target.value)}>
      <option value="" disabled>
        {placeholder}
      </option>
      {options.map((opt) => (
        <option key={opt} value={opt}>
          {opt}
        </option>
      ))}
    </select>
    <ArrowDownIcon className="lm-icon-arrow" width="24" height="24" />
  </div>
);

const ManualDriverModal = ({ onHide, onSubmit, onCancel, dlNumber = "TN02202000019019", show }) => {
  const close = onHide || onCancel;
  const success = onSubmit;
  const [issueDate, setIssueDate] = useState("");
  const [expiryDate, setExpiryDate] = useState("");
  const [status, setStatus] = useState("Active");

  if (!show) return null;

  const handleCancel = () => {
    if (close) close();
  };

  const handleSubmit = () => {
    if (success) {
      success({ issueDate, expiryDate, status });
    }
  };

  return (
    <div className="lm-overlay">
      <div className="lm-container">
        <div className="lm-header">
          <div className="lm-header-left">
          <h2 className="lm-title">License info</h2>
          </div>
          <div className="lm-header-right">
            <div className="lm-badge">
              <span className="lm-badge-label">Lic. No : </span>
              <span className="lm-badge-value">{dlNumber}</span>
            </div>
            <div className="lm-close-circle" onClick={handleCancel}>
              <ModalCloseIcon width="14" height="14" />
            </div>
          </div>
        </div>

        <div className="lm-body">
          <FormField label="Issue date">
            <DateInput value={issueDate} onChange={setIssueDate} />
          </FormField>

          <FormField label="Expiry date" required>
            <DateInput value={expiryDate} onChange={setExpiryDate} />
          </FormField>

          <FormField label="Status">
            <SelectInput value={status} options={STATUS_OPTIONS} onChange={setStatus} />
          </FormField>
        </div>

        <div className="lm-footer">
          <button className="lm-btn-cancel" onClick={handleCancel}>
            Cancel
          </button>
          <button className="lm-btn-submit" onClick={handleSubmit}>
            Submit
          </button>
        </div>
      </div>
    </div>
  );
};

export default ManualDriverModal;
